<template>
  <div class="">
    <el-form
      :model="form"
      :rules="rules"
      ref="form"
      label-width="100px"
      class="demo-form"
      size="small"
    >
      <el-form-item :label="$t('ltlwork.form.workOrderTitle')" prop="title">
        <el-input v-model="form.title" :placeholder="$t('ltlwork.form.pleaseEnterWorkOrderTitle')"></el-input>
      </el-form-item>
      <el-form-item :label="$t('ltlwork.form.orderNo')" prop="order_sn">
        <el-input v-model="form.order_sn" :placeholder="$t('ltlwork.form.pleaseEnterOrderNo')"></el-input>
      </el-form-item>
      <el-form-item :label="$t('ltlwork.form.description')" prop="describe">
        <el-input type="textarea" v-model="form.describe" :placeholder="$t('ltlwork.form.pleaseEnterDescription')"></el-input>
      </el-form-item>
      <el-form-item :label="$t('ltlwork.form.uploadFile')" prop="file">
        <el-upload
          :class="fileList.length >= 1 ? 'no-upload-file' : ''"
          action="https://uudex.com/wapi/common/upload"
          list-type="picture-card"
          :on-success="handleSuccess"
          :on-remove="handleRemove"
          :file-list="fileList"
          :limit='1'
          :before-upload="handleBeforeUpload"
        >
          <i class="el-icon-plus"></i>
        </el-upload>
      </el-form-item>
      <el-form-item style="text-align: right;">
        <el-button size="small" type="primary" @click="submitForm('form')">{{ $t('ltlwork.form.submit') }}</el-button>
        <el-button size="small" @click="resetForm('form')">{{ $t('ltlwork.form.reset') }}</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { workAdd } from '@/api/ltl/work'
export default {
  props:{
    record: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      form: {},
      rules: {
        title: [{ required: true, message: this.$t('ltlwork.form.pleaseEnterWorkOrderTitle'), trigger: "blur" }],
        order_sn: [{ required: true, message: this.$t('ltlwork.form.pleaseEnterOrderNo'), trigger: "blur" }],
        describe: [{ required: true, message: this.$t('ltlwork.form.pleaseEnterDescription'), trigger: 'blur' }],
      },
      id:'',
      fileList: [],
    };
  },
  methods: {
    handleBeforeUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!isLt2M) {
        this.$message.error(this.$t('ltlwork.form.uploadSizeLimit'));
      }
      return isLt2M;
    },
    handleSuccess(res) {
      let list = [{
        label: res.data.url,
        value: res.data.fullurl,
        url: res.data.fullurl
      }];
      this.fileList = list;
    },
    handleRemove(file) {
      this.fileList = [];
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let form = this.form
          workAdd({
            u_id: JSON.parse(window.localStorage.getItem("userInfo1")).user_id,
            ...form,
            file: this.fileList.length > 0 ? this.fileList[0].label : "",
          }).then(res => {
            if(res.code == 1){
              this.$message.success(res.msg)
              this.$emit('ok')
            }else{
              this.$message.error(res.msg)
            }
          }).catch(err => {
            this.$message.error(err.msg)
          })
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.form = {}
    },
  },
};
</script>
<style lang="scss" scoped>
  ::v-deep .no-upload-file .el-upload--picture-card {
    display: none !important;
  }
  /deep/.el-upload--picture-card{
    width: 100px;
    height: 100px;
    line-height: 98px;
  }
  /deep/.el-upload-list--picture-card .el-upload-list__item{
    width: 100px;
    height: 100px;
  }
</style>